/**
 * Setea valor de parametro en URL
 * @param {string} param Parametro
 * @param {string} param nuevo valor
 * @returns 
 */
export default function setUrlParam(param = '', value = '') {
    const nQuery = (typeof window !== 'undefined')
        ? new URLSearchParams(window.location.search)
        : new URLSearchParams();

    if (value.trim() !== '') {
        nQuery.set(param, value);
    } else {
        nQuery.delete(param);
    }

    if (typeof window !== 'undefined') {
        const { protocol, pathname, host } = window.location;
        const newUrl = `${protocol}//${host}${pathname}?${nQuery.toString()}`;
        window.history.replaceState({}, '', newUrl);
        window.dispatchEvent(new Event('urlchange'));
    }
}